<div class="soc-confirmation-dialog">
    <div class="confirmation-text-wrapper">
        <p class="soc-panel-h">{{dialogTitle}}</p>
        <p class="soc-p">{{dialogText}}</p>
    </div>
    <div class="confirmation-btn-wrapper">
        <button class="soc-secondary-cyan-btn">Cancel</button>
        <button class="soc-basic-cyan-btn">Confirm</button>
    </div>
</div>